import { useMemo } from 'react'
import { useImageOrganizeModes, useGroupData } from '../../../views/imageBrowse/hooks'
import useViewMode from '../../../views/imageBrowse/hooks/useViewMode'

export default function useImageBrowserGroup() {
  const { viewMode } = useViewMode()
  const { isDivideMode } = useImageOrganizeModes()
  const { initialGroup, group: currentChildGroup } = useGroupData()
  const group = useMemo(
    () => (isDivideMode || viewMode === 'group' ? initialGroup : currentChildGroup),
    [initialGroup, currentChildGroup, isDivideMode, viewMode]
  )

  return group
}
